module.exports = {"469003100":"那大镇","469003101":"和庆镇","469003102":"南丰镇","469003103":"大成镇","469003104":"雅星镇","469003105":"兰洋镇","469003106":"光村镇","469003107":"木棠镇","469003108":"海头镇","469003109":"峨蔓镇","469003110":"三都镇","469003111":"王五镇","469003112":"白马井镇","469003113":"中和镇","469003114":"排浦镇","469003115":"东成镇","469003116":"新州镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469003.json
// module id = 2198
// module chunks = 0